/**
 *  UserModal.jsx
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 05/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

 // system
import React, { Component } from "react";

// template
import { Modal, Button } from "react-bootstrap";

// global
var utils = require("../../utils");

export class DeforestationModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    closeModal = () => {
        this.props.handleHide();
    }

    modalMap(){
        const { url, rowSelected } = this.props;

        if (url != ""){
            return (
                <div>
                    <h5 style={{fontWeight: 'bold'}}>DATA E HORA: {utils.dateTimeFormatter(rowSelected.createdAt)}</h5>
                    <iframe 
                        src={url}  
                        style={{ width: "100%", height: "400px", background: "transparent", border: "none"}} 
                        className=""
                    />
                </div>
            )
        } 
    }

    render() {
        const { show } = this.props;
        return (
            <Modal show={show}>
                <Modal.Body>
                    {this.modalMap()}
                </Modal.Body>
                <Modal.Footer>
                    <Button className='btn btn-danger' onClick={this.closeModal}>FECHAR</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default DeforestationModal;



// WEBPACK FOOTER //
// ./src/views/DeforestationReport/DeforestationModal.jsx